// import React from 'react';

// const getYouTubeEmbedUrl = (url) => {
//     if (url.includes('youtu.be')) {
//         const id = url.split('/').pop();
//         return `https://www.youtube.com/embed/${id}`;
//     } else if (url.includes('youtube.com/watch')) {
//         const id = new URL(url).searchParams.get('v');
//         return `https://www.youtube.com/embed/${id}`;
//     }
//     return '';
// };

// export default function PostVideoCard({ videoUrl, category, title, subTitle, href }) {
//     const embedUrl = getYouTubeEmbedUrl(videoUrl);

//     return (
//         <div className="cs_post_video_card mb-5">
//             <div className="video-wrapper mb-3">
//                 <iframe
//                     width="960px"
//                     height="540px"
//                     src={embedUrl}
//                     title={title}
//                     frameBorder="0"
//                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                     allowFullScreen
//                 ></iframe>
//             </div>
//             <div className="post-content">
//                 <span className="category d-block mb-1">{category}</span>
//                 <h3 className="title mb-2"><a href={href}>{title}</a></h3>
//                 <p className="subTitle">{subTitle}</p>
//             </div>
//         </div>
//     );
// }

// import React from 'react';

// const getYouTubeEmbedUrl = (url) => {
//     if (url.includes('youtu.be')) {
//         const id = url.split('/').pop();
//         return `https://www.youtube.com/embed/${id}`;
//     } else if (url.includes('youtube.com/watch')) {
//         const id = new URL(url).searchParams.get('v');
//         return `https://www.youtube.com/embed/${id}`;
//     }
//     return '';
// };

// export default function PostVideoCard({
//     videoUrl,
//     category,
//     title,
//     subTitle,
//     href,
//     width = '100%',      // Default width
//     height = '400px',     // Default height
// }) {
//     const embedUrl = getYouTubeEmbedUrl(videoUrl);

//     return (
//         <div className="cs_post_video_card mb-5">
//             <div className="video-wrapper mb-3">
//                 <iframe
//                     width={width}
//                     height={height}
//                     src={embedUrl}
//                     title={title}
//                     frameBorder="0"
//                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                     allowFullScreen
//                 ></iframe>
//             </div>
//             <div className="post-content">
//                 <span className="category d-block mb-1">{category}</span>
//                 <h3 className="title mb-2"><a href={href}>{title}</a></h3>
//                 <p className="subTitle">{subTitle}</p>
//             </div>
//         </div>
//     );
// }



// import React from 'react';
// import { Link } from 'react-router-dom';

// // const getYouTubeEmbedUrl = (url) => {
// //   if (url.includes('youtu.be')) {
// //     const id = url.split('/').pop();
// //     return `https://www.youtube.com/embed/${id}`;
// //   } else if (url.includes('youtube.com/watch')) {
// //     const id = new URL(url).searchParams.get('v');
// //     return `https://www.youtube.com/embed/${id}`;
// //   }
// //   return '';
// // };
// const getYouTubeEmbedUrl = (url) => {
//     try {
//       if (url.includes('youtu.be')) {
//         const id = url.split('/').pop();
//         return `https://www.youtube.com/embed/${id}`;
//       } else if (url.includes('youtube.com/watch')) {
//         const id = new URL(url).searchParams.get('v');
//         return `https://www.youtube.com/embed/${id}`;
//       } else if (url.includes('youtube.com/shorts')) {
//         const id = url.split('/shorts/')[1].split('?')[0];
//         return `https://www.youtube.com/embed/${id}`;
//       }
//     } catch (error) {
//       console.error('Invalid YouTube URL:', url);
//     }
//     return '';
//   };
  

// export default function PostVideoCard({
//   videoUrl,
//   category,
//   title,
//   subTitle,
//   href,
//   width = '100%',
//   height = '400px',
//   reverse = false, // NEW PROP
// }) {
//   const embedUrl = getYouTubeEmbedUrl(videoUrl);

//   return (
//     <div className="cs_post_video_card mb-5">
//       <div className={`row align-items-center ${reverse ? 'flex-row-reverse' : ''}`}>
//         <div className="col-lg-6">
//           <div className="video-wrapper mb-3">
//             <iframe
//               width={width}
//               height={height}
//               src={embedUrl}
//               title={title}
//               frameBorder="0"
//               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//               allowFullScreen
//               className="cs_radius_15 w-100"
//             ></iframe>
//           </div>
//         </div>
//         <div className="col-lg-6">
//           <div className="post-content px-lg-5">
//             <span className="category d-block mb-1">{category}</span>
//             <h3 className="title mb-2">
//               <Link to={href}>{title}</Link>
//             </h3>
//             <p className="subTitle">{subTitle}</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


const getYouTubeEmbedUrl = (url) => {
    try {
      if (url.includes('youtu.be')) {
        const id = url.split('/').pop();
        return { embedUrl: `https://www.youtube.com/embed/${id}`, isShort: false };
      } else if (url.includes('youtube.com/watch')) {
        const id = new URL(url).searchParams.get('v');
        return { embedUrl: `https://www.youtube.com/embed/${id}`, isShort: false };
      } else if (url.includes('youtube.com/shorts')) {
        const id = url.split('/shorts/')[1].split('?')[0];
        return { embedUrl: `https://www.youtube.com/embed/${id}`, isShort: true };
      }
    } catch (error) {
      console.error('Invalid YouTube URL:', url);
    }
    return { embedUrl: '', isShort: false };
  };
  
  export default function PostVideoCard({
    videoUrl,
    category,
    title,
    subTitle,
    href,
    width = '100%',
    height = '400px',
    reverse = false,
  }) {
    const { embedUrl, isShort } = getYouTubeEmbedUrl(videoUrl);
  
    return (
      <div className="cs_post_video_card mb-5">
        <div className={`row align-items-center ${reverse ? 'flex-row-reverse' : ''}`}>
          <div className="col-lg-6">
            <div className="video-wrapper mb-3 d-flex justify-content-center">
              <iframe
                width={isShort ? '400px' : width}
                height={isShort ? '533px' : height}
                src={embedUrl}
                title={title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="cs_radius_15"
                style={{ maxWidth: '100%' }}
              ></iframe>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="post-content px-lg-5">
              <span className="category d-block mb-1">{category}</span>
              <h3 className="title mb-2">
                <a href={href}>{title}</a>
              </h3>
              <p className="subTitle">{subTitle}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
  